import React, { useState, useEffect } from "react";
import { HiMiniBars3 } from "react-icons/hi2";
import { useSelector } from "react-redux";
import { useNavigate, useNavigation } from "react-router-dom";
import { FaAngleDown } from "react-icons/fa6";
import useComponentVisible from "hooks/click-outside-hook";
import useStore from "hooks/useStore";
import dpIcon from "assets/images/common/others/dpIcon.png";
import { ReactComponent as NotificationIcon } from "assets/images/common/svgs/notification-bing.svg";
import useOutsideClick from "hooks/click-outside-hook";
import { siteRoutes } from "utils/helpers/enums/routes.enum";
import useNavigations from "./useHooks";

interface Notification {
  isRead: boolean;
  sender: {
    image: string;
    name: string;
    id: string;
  };
}

const Navbar: React.FC = () => {
  const [user, setUser] = useState<any | null>(null);
  const [data, setData] = useState<any>({});
  const { readNotification, getNotificationCount } = useNavigations();
  const [profileDropDownOpened, setProfileDropdownOpened] = useState(false);
  const profileDropdownRef = useOutsideClick(() =>
    setProfileDropdownOpened(false)
  );

  const navigate = useNavigate();
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    currentRole: "",
  });

  useEffect(() => {
    const storedUser = localStorage.getItem("userData");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUserData({
        firstName: parsedUser.firstName || "",
        lastName: parsedUser.lastName || "",
        currentRole: parsedUser.currentRole || "",
      });
    }
  }, []);

  const isSidebarExpanded = useSelector(
    (state: any) => state.sharedReducer?.isSidebarExpanded ?? true
  );

  const { setExpandSidebar } = useStore();

  const handleExpandSidebar = () => {
    setExpandSidebar(!isSidebarExpanded);
  };

  const logout = () => {
    localStorage.clear();
    navigate(siteRoutes.login);
  };

  const handleNotificationClick = async () => {
    await readNotification();
    await getAllCount();
    navigate(siteRoutes.notificationListing);
  };

  const getAllCount = async () => {
    await getNotificationCount(setData);
  };

  useEffect(() => {
    getAllCount();
  }, []);

  return (
    <div className="h-24 bg-white w-full flex justify-between items-center">
      <div className="xs:px-2 px-5">
        <HiMiniBars3
          size={30}
          color="#000000"
          className="cursor-pointer"
          onClick={handleExpandSidebar}
        />
      </div>
      <div className="xs:px-2 px-5 flex items-center gap-4">
        <div className="relative">
          <div onClick={handleNotificationClick} className="cursor-pointer">
            <div className="absolute -right-1.5 -top-2 bg-darkTealBlue text-white text-xs text-center p-2.5 flex justify-center items-center font-bold rounded-full w-4 h-4">
              {data?.unreadNotifications || 0}
            </div>

            <NotificationIcon className="w-7 h-7" />
          </div>
        </div>

        <div
          className=" p-3 flex justify-center items-center gap-3 sm:gap-5 cursor-pointer"
          onClick={() => setProfileDropdownOpened(!profileDropDownOpened)}
        >
          <img
            src={dpIcon}
            className="w-10 h-10 my-auto rounded-full"
            alt="avatar"
          />
          <div>
            <h5 className="text-sm font-bold text-[#404040] whitespace-nowrap">
              {`${userData.firstName} ${userData.lastName}`}
            </h5>
            <p className="text-xs font-semibold text-[#9C9C9C]">
              {userData.currentRole.replace(/_/g, " ")}
            </p>
          </div>
          <div className="p-1.5 rounded-full border-[0.5px] border-[#5C5C5C]">
            <FaAngleDown size={18} color={"#565656"} />
          </div>
        </div>
        {profileDropDownOpened && (
          <div
            ref={profileDropdownRef}
            className="absolute z-10 top-[5rem] right-8 h-fit w-56 bg-white rounded-md shadow p-3 flex flex-col justify-evenly"
          >
            {/* <p
              className="font-semibold text-sm text-[#1C1C27] cursor-pointer"
              onClick={() => navigate("/dashboard/profile")}
            >
              Profile
            </p>
            <hr className="bg-[#E2E8F0] h-[1.7px]" />
            <p
              className="font-semibold text-sm text-[#1C1C27] cursor-pointer"
              onClick={() => navigate("/dashboard/setting")}
            >
              Settings
            </p> */}
            {/* <hr className="bg-[#E2E8F0] h-[1.7px]" /> */}
            <p
              className="font-semibold text-sm text-[#FF0000] cursor-pointer"
              onClick={logout}
            >
              Logout
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
